<template>
  <div class="flex text-gray-900" v-if="status">
    <div
      class="rounded-full w-2 h-2 mr-2 self-center bg-gray-400"
      :class="{ 'bg-green-500': status.identifier == 'customer' }"
    ></div>
    <span>{{ status.name }}</span>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: Object,
      required: true
    }
  }
};
</script>